<template>
    <InputFile name="files"
               :multiple="model.multipleFiles"
               :required="model.required"/>
</template>


<script lang="ts" setup>
import { FileSelectorBlock } from '@/api/content/models';
import InputFile from '../forms/InputFile.vue';

type Props = {
    model: FileSelectorBlock
}

defineProps<Props>();

</script>